var getNative=require("./getNative"),WeakMap=getNative(global,"WeakMap"),metaMap=WeakMap&&new WeakMap;module.exports=metaMap;